import { useState, useEffect } from "react";
import Loading from "../loading";
import GetAdmin from "../../utils/getAdmin";
import NotFoundPage from "./404";
import "../../assets/fonts.css";
import Navigation from "../Navigation";
import QuestionTable from "../tables/QuestionTable";
import Notification from "../Notification";
import GiftForm from "../Forms/giftForm";

const Gift = () => {
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [questionData, setQuestionData] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [status, setStatus] = useState();
  const [refresh, setRefresh] = useState(true);
  const [edit, setEdit] = useState(false);
  const [phone, setPhone] = useState("");
  const [credit, setCredit] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await GetAdmin();
        setAdminData(res);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [refresh]);

  if (loading) {
    return <Loading />;
  }

  if (!adminData) {
    return null;
  }

  const getNotificationProps = () => {
    switch (status) {
      case 200:
        return {
          message: "ارسال هدیه موفقیت آمیز بود",
          type: "success",
          duration: 3000,
        };

      case 404:
        return {
          message: "کاربری با این شماره تماس وجود ندارد",
          type: "error",
          duration: 3000,
        };

      case 400:
        return {
          message: "ارسال هدیه شکست خورد",
          type: "error",
          duration: 3000,
        };

      case 500:
        return {
          message: "مشکل سرور به برنامه نویس اطلاع دهید",
          type: "error",
          duration: 3000,
        };
      default:
        return null;
    }
  };

  const notificationProps = getNotificationProps();

  if (adminData.role === "manager" || adminData.role === "questionMaker") {
    return (
      <>
        <div class="w-full flex justify-center flex-col items-center">
          {showNotification ? (
            <Notification
              {...notificationProps}
              setShowNotification={setShowNotification}
              showNotification={showNotification}
            />
          ) : null}

          {/* فیلد ساخت سوال  */}
          <div class="flex flex-col md:flex-row gap-6 justify-between w-full">
            <div className="w-full md:w-1/4 mb-6 lg:mb-0">
              <Navigation />
            </div>
            <div class="w-full md:w-3/4 ">
              <div className="w-full flex col-span-4 flex-col gap-4 shadow-lg bg-white rounded-lg">
                <GiftForm
                  setStatus={setStatus}
                  setShowNotification={setShowNotification}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <NotFoundPage />;
  }
};

export default Gift;
